angular.module('mtic.components.modules.gr78').
directive('lmapSidepanelNode', function ($log, language, EventManager, PanelStateService) {
  return {

    templateUrl: 'template.html',
    scope: {
      'resource' : '=',
      'moduleMapData': '='
    },

    link: function (scope, element) {
      var eventManager = new EventManager('lmapSidepanelNode', scope)

      scope.selected = false;
      scope.subresources = [];
      scope.databaseResource = {};
      var activeAgenda = null;
      var interpeteAgendaLockStatus = function(){
        if(activeAgenda.force_unlock === true) {
          return 'unlock';
        } else if(activeAgenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      }
      scope.$watch('resource', function(resource){
        if(resource){
   //       $log.debug('[[lmapSidepanelNode]] rendering', scope.resource, resource)
          scope.subresources = resource.sub || [];
          scope.databaseResource = getDbResource(resource.slug);
        }
      })

      eventManager.listen('moduleview:agenda:selected', function(e, agenda) {
        activeAgenda = agenda;
      })
      eventManager.listen('module:select:resource', function(e, data) {
        if (data.slug === scope.resource.slug)
        {
          scope.selected = true;
        } else {
          scope.selected = false;
        }
      })
      eventManager.listen('module:dismiss:focus', function(e, data) {
          scope.selected = false;

      })

      scope.itemIsLocked = function(){
        var isLocked = scope.databaseResource ? scope.databaseResource.locked : true;
        if(activeAgenda && activeAgenda.resources && scope.databaseResource && activeAgenda.resources.indexOf(scope.databaseResource.id) > -1) {
          switch(interpeteAgendaLockStatus()) {
            case 'unlock':
              return false;
            case 'lock':
              return true;
          }
        }
        return isLocked;
      }
      scope.getName = function(){
        var name;
        /*
        if(scope.resource.slug && scope.resource.slug.indexOf("_m0")>1){
          name = language.get(scope.resource.slug+'_short');
        }else{
          name = language.get(scope.resource.slug);
        }*/

        name = language.get(scope.resource.slug);

        if (!name){
          if(scope.databaseResource.name) {
            name = scope.databaseResource.name;
          }else{
            name = scope.resource.slug
          }
        }
        return name;
      }

      scope.getIconCssClasses = function(){
        var shape = '';
        var color = '';
        if (scope.resource.slug === 'mtic_g78_m1_diag'){
          color = 'color-bubble-icon-assessment'
          shape = 'fa-check-circle';
        }
        else{
          if (scope.subresources.length > 0){
            color = 'color-bubble-icon-group'
            shape = 'fa-stop';
          }
          else{

            color = 'color-bubble-icon-' + (scope.databaseResource.display && scope.databaseResource.display.color ? scope.databaseResource.display.color : 'blue');
            shape = 'fa-circle';
            // var databaseResource = getDbResource(scope.resource.slug);
            if (scope.databaseResource.complete){
              shape = 'fa-check-circle';
            }
          }
        }
        return shape + ' ' + color;
      }

      scope.onNodeClick = function (){
        if (scope.subresources.length > 0){
          toggleExpansion();
        }
        else{
          if (!scope.itemIsLocked()){
            // var item_evt_info = {
            //   slug : scope.databaseResource.slug,
            //   id : scope.databaseResource.id
            // }
              eventManager.broadcast( 'module:select:resource', scope.databaseResource );
              eventManager.broadcast( 'module:center:resource', scope.databaseResource );
          }
        }
      }

      scope.getStyleModifiers = function(){
        if (scope.subresources.length > 0){
          return {};
        }
        else{
          return {'font-weight':'bold'};
        }
      }

      var toggleExpansion = function(){
        scope.resource.isExpanded = !scope.resource.isExpanded;
        PanelStateService.setResourceExpanded(scope.resource.slug, scope.resource.isExpanded);
      }

      var getDbResource = function(slug, resources){
        var passedChildren = false;
        if(!resources) {
          if(scope.moduleMapData && scope.moduleMapData.children) {
            resources = scope.moduleMapData.children;
          }else if(scope.moduleMapData && scope.moduleMapData.resources && Array.isArray(scope.moduleMapData.resources)){
            resources = scope.moduleMapData.resources;
          } else{
            $log.warn('[[lmapSidepanelNode]] MISSING CHILDREN FOR `moduleMapData`')
            resources = [];
          }
        }else{
          passedChildren = true;
        }
        
        for (var i = 0; i < resources.length; i++) {
          var resource = resources[i];
          if(resource.slug === slug){
            return resource;
          }
          if(resource.children && resource.children.length > 0) {
            resource = getDbResource(slug, resource.children)
            if(resource) {
              return resource;
            }
          }
        }
        if(passedChildren){
          return false;
        }else{
          $log.warn("[[lmapSidepanelNode]] Could not find databaseResource for ", slug, scope)
          return {};
        }
      }

      if (scope.resource && !language.get(scope.resource.slug)){
        $log.warn('No text defined for ', scope.resource.slug)
      }

      if (scope.resource && PanelStateService.getResourceExpanded(scope.resource.slug))
      {
        toggleExpansion();
      }
    }
  }
});
